/* eslint-disable no-unused-vars */
import Vue from 'vue'

import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'
import auth from './auth'
import Vuesax from 'vuesax'
import axios from 'axios';
import db from './db'

import initProgress from './progressbar'
import '../node_modules/nprogress/nprogress.css'
import VueParticles from 'vue-particles'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import 'material-icons/iconfont/material-icons.css';

import firebase from './fb'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag';
import VueGtm from '@gtm-support/vue2-gtm';
const crypto = require('crypto');
import { jwtDecode } from "jwt-decode";
const buffer = require('buffer');

import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import QrcodeVue from "qrcode.vue";
var bcrypt = require("bcryptjs");
window.swal = require('sweetalert')

import VueMeta from 'vue-meta';

Vue.use(VueMeta);


const InstantChange = () => import("./components/instant_change/instant.vue");
const InstantChangeAlert = () => import("./components/instant_change/instant_change_alert_message.vue");
const Notice = () => import("./components/instant_change/Notice.vue");
import device from "vue-device-detector"
Vue.use(device)
import { mapGetters, mapActions } from 'vuex'



import './registerServiceWorker'


Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(VueParticles);


// Vue.use(VueAnalytics, {
//   id: 'UA-144172744-1',
//   router
// })

Vue.use(VueGtag, {
  config: { id: 'G-57ZD80D4F5' } // Replace with your GA4 Measurement ID
}, router);


Vue.mixin({
  components: {
    InstantChange,
    InstantChangeAlert,
    QrcodeVue,
    Notice
  },
  data() {
    return {
      main_api: process.env.VUE_APP_MAIN_API,
      base_url: process.env.VUE_APP_BASE_URL,
      axios_user: process.env.VUE_APP_axios_user,
      axios_password: process.env.VUE_APP_axios_password,
      account_status: '',
  
      unsubscribeInstantData: null,
      instantData:{}

    }
  },

  computed: {
    axios_auth() {
      return {
        auth: {
          username: this.axios_user,
          password: this.axios_password
        }
      }
    }
  },

  beforeDestroy() {
    if (this.unsubscribeInstantData) {
        //this.unsubscribeInstantData();
        console.log('subcribe destroyed');
        // Désabonnement quand le composant est détruit
    }
},

  mounted() {
    const currentUser = firebase.auth().currentUser
    currentUser ? this.account_status = currentUser.displayName : ""
    const func = () => {
      let inactivityTime = 0;
      const inactivityLimit = 15 * 60 * 1000; // 15 minutes
      // Reset inactivity timer on user activity
      function resetInactivityTimer() {
        inactivityTime = 0;
      }
      // Set up activity listeners
      window.onload = resetInactivityTimer;
      document.onmousemove = resetInactivityTimer;
      document.onkeypress = resetInactivityTimer;

      setInterval(() => {
        inactivityTime += 1000; // Increment by 1 second
        if (inactivityTime >= inactivityLimit) {
          //signOutUser();
        }
      }, 1000);
    }
    func()
  },
  created () {
    this.initializePaymentMethods();
  },

  methods: {
    valid_auth_pin: async (code) => {
      console.log(code);
      
      let auth_activated = store.getters['authfb/user'].auth2fa.google
      let user_id = store.getters['authfb/user'].id
      console.log(auth_activated, user_id);
      let valid
      //google auth verification
      let google_auth = async (token) => {
        console.log('google auth verification');
        try {
          let idToken = await firebase.auth().currentUser.getIdToken(true)
          let auth_token = {
            headers: { Authorization: `Bearer ${idToken}` }
          }
          let base_url = process.env.VUE_APP_BASE_URL
          if (location.hostname === "localhost") {
            base_url = 'http://localhost:4000'
          }
          let url = base_url + '/auth_pay/verify-2fa'
          console.log(url);
          
          let { data } = await axios.post(url, { token, user_id }, auth_token)
          console.log(data);
          return data.success
        } catch (error) {
          console.log(error);
          return false;
        }
      }
      //pin code verification
      let pin_valid = async (pin) => {
        var hash = store.getters["authfb/pin"];
        return await bcrypt.compare(pin, hash)
      }
      valid = auth_activated ? await google_auth(code) : await pin_valid(code)
      return valid
    },

    async firebase_auth_token() {
      console.log('firebase auth');
      let auth
      await firebase.auth().currentUser.getIdToken(true).then(async token => {
        auth = {
          headers: { Authorization: `Bearer ${token}` }
        };
      }).catch(e => {
        console.log(e);
        auth = null
      })
      return auth;
    },

    async verify_identity() {
      this.$router.push('/verify')
    },

    async decode(payload) {
      let { token, et, neq } = payload;
      for (let i = 0; i < neq; i++) {
        token += '=';
      }
      const decode_token = (input, num) => {
        let decoded = Buffer.from(input, 'base64').toString('ascii')
        if (num === 1) {
          return JSON.parse(decoded)
        }
        let newvalue = num - 1
        return decode_token(decoded, newvalue)
      }

      let decoded = decode_token(token, et)

      return decoded
    },

    async encode(input) {
      let random_number = Math.floor(Math.random() * 10) + 1;;
      console.log(random_number);

      let encode_token = (data, num) => {
        let encoded = Buffer.from(JSON.stringify(data)).toString('base64')
        if (num === 1) {
          return encoded
        }
        let newvalue = num - 1
        return encode_token(encoded, newvalue)
      }

      let encoded_string = encode_token(input, random_number)
      let encoded_split = encoded_string.split('=')
      let x_token = encoded_split[0]
      let neq = encoded_split.length - 1
      let et = random_number

      return { x_token, neq, et }
    },

    async get_headers(input) {
      let random_number = Math.floor(Math.random() * 10) + 1;
      console.log(random_number);

      let encode_token = (data, num) => {
        let encoded = Buffer.from(JSON.stringify(data)).toString('base64')
        if (num === 1) {
          return encoded
        }
        let newvalue = num - 1
        return encode_token(encoded, newvalue)
      }


      let encoded_string = encode_token(input, random_number)
      let encoded_split = encoded_string.split('=')
      let x_token = encoded_split[0]
      let neq = encoded_split.length - 1
      let et = random_number
      let auth_token = await this.firebase_auth_token()
      let { headers } = auth_token
      headers['x_token'] = x_token
      headers['neq'] = neq
      headers['et'] = et
      auth_token.headers = headers
      return auth_token

    },

    validPhoneNumber(payload) {
      let { number, moyen } = payload;
      moyen = moyen.toLowerCase();
      let expectedNumberLength = 0
      if (['togo', 'tm', 'flooz', 'bf', 'burkina', 'mali', 'ml'].some(word => moyen.includes(word))) {
        expectedNumberLength = 8;
      } else if (['sn', 'senegal'].some(word => moyen.includes(word))) {
        expectedNumberLength = 9;
      } else if (['bj', 'benin', 'ci', 'civ', 'cote'].some(word => moyen.includes(word))) {
        expectedNumberLength = 10;
      }
      let numberValid = number.toString().length == expectedNumberLength ? true : false;
      let returnData = {numberValid, expectedNumberLength: expectedNumberLength} 
     return  returnData
    },

    csurfApi(){
      const api = axios.create({
        withCredentials: true
      });
      
      // Variable pour stocker la promesse du token en cours
      let csrfTokenPromise = null;
      
      // Fonction pour obtenir le token
      const getCsrfToken = async () => {
        if (csrfTokenPromise) {
          return csrfTokenPromise;
        }
      
        const baseurl = location.hostname === "localhost" 
          ? 'http://localhost:4000'
          :this.base_url;
      
          console.log('csurf_config ', baseurl);
          
        csrfTokenPromise = axios.get(`${baseurl}/generate_csurf`)
          .then(response => response.data.csrfToken)
          .finally(() => {
            setTimeout(() => {
              csrfTokenPromise = null;
            }, 1000);
          });
      
        return csrfTokenPromise;
      };
      
      // Intercepteur pour les requêtes
      api.interceptors.request.use(async config => {
        // Récupérer les headers existants de votre get_headers si nécessaire
        const existingHeaders = config.headers || {};

        if (!config.headers['X-CSRF-Token']) {
          const csrfToken = await getCsrfToken();
          if (csrfToken) {
            config.headers = {
              ...existingHeaders,
              'X-CSRF-Token': csrfToken
            };
          }
      }
        return config;
      });
  return api
    },

    initializePaymentMethods(){
      let docRef = db.collection('instant').doc('paymentMethods');
      // Initialize prices structure
      this.unsubscribeInstantData = docRef.onSnapshot((snapshot) => {
          console.log(snapshot.data());
          this.paymentMethods = snapshot.data()
          
      });
      // Initialize price structure for all countries and crypto
  },

    
  },
})





Vue.use(VueGtm, {
  id: 'GTM-MFWWZMT', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  //nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  //ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#5b3cc4',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      dark: 'rgb(36, 33, 69)'
    }
  }
})

Vue.config.productionTip = false
initProgress(router);

let app

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({

      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})


